import { apiCall, ApiResponse } from "./apiClient";
import type { VehicleMaintenanceReminderDto } from "../models/vehicleMaintenance/vehicleMaintenanceReminder";

export const markMaintenanceDone = async (
    vehicleMaintenanceId: string,
    signal?: AbortSignal
): Promise<ApiResponse<VehicleMaintenanceReminderDto>> => {
    return apiCall<VehicleMaintenanceReminderDto>(
        `vehiclemaintenancereminder/markDone/${vehicleMaintenanceId}`,
        "POST",
        undefined,
        signal
    );
};
